// ============================================
// GRUPOSPROYECTOS.JS — Grupos de proyectos con timeline
// ============================================

import React, { useState } from 'react';
import { BarraBusqueda, ContadorResultados } from './utils/filtros';
import { BadgeFolio } from './utils/folios';
import { OPC_DINERO } from './utils/dinero';

const PP = "'Poppins', sans-serif";
const colores = { principal: '#5c9adb', oscuro: '#2f5f9e', gris: '#4e5357', grisClaro: '#5e666e', verde: '#5cd4b0', rojo: '#e05c5c', fondo: '#f3f4f4' };

const gruposData = [
  {
    id: 1, nombre: 'Bodegas Alianza — Expansión 2024-2026', cliente: 'Bodegas Alianza',
    proyectos: [
      { folio: 'PRY-2024-001', nombre: 'Instalación CCTV Bodega Central', fecha: '2024-09-15', monto: 245000, estatus: 'Cerrado', equipos: 12, tecnico: 'Miguel G.' },
      { folio: 'PRY-2025-001', nombre: 'Migración IP Bodega Central', fecha: '2025-03-01', monto: 180000, estatus: 'Cerrado', equipos: 8, tecnico: 'Miguel G.' },
      { folio: 'PRY-2026-001', nombre: 'CCTV 4K Bodega Norte MTY', fecha: '2026-03-15', monto: 320000, estatus: 'En ejecución', equipos: 16, tecnico: 'Miguel G.' },
    ],
    totalInvertido: 745000, totalEquipos: 36, totalTecnicos: 3, tiempoTotal: '18 meses',
  },
  {
    id: 2, nombre: 'Farma Plus — Seguridad integral', cliente: 'Farma Plus',
    proyectos: [
      { folio: 'PRY-2024-002', nombre: 'CCTV Farma Plus Matriz', fecha: '2024-11-01', monto: 95000, estatus: 'Cerrado', equipos: 6, tecnico: 'Pedro R.' },
      { folio: 'PRY-2026-002', nombre: 'Mantenimiento semestral', fecha: '2026-02-01', monto: 28000, estatus: 'En ejecución', equipos: 0, tecnico: 'Pedro R.' },
    ],
    totalInvertido: 123000, totalEquipos: 6, totalTecnicos: 2, tiempoTotal: '16 meses',
  },
];

const estCfg = { 'En ejecución': { bg: '#e6f1fb', color: '#2f5f9e' }, Cerrado: { bg: '#e8faf5', color: '#1D9E75' }, Programado: { bg: '#fffbe6', color: '#7a6e00' } };

function GruposProyectos() {
  const [busqueda, setBusqueda] = useState('');
  const [detalleId, setDetalleId] = useState(null);
  const [width] = useState(window.innerWidth);
  const esCelular = width < 768;

  const filtrados = gruposData.filter(g => {
    if (busqueda) { const q = busqueda.toLowerCase(); return g.nombre.toLowerCase().includes(q) || g.cliente.toLowerCase().includes(q); }
    return true;
  });

  if (detalleId) {
    const g = gruposData.find(x => x.id === detalleId);
    if (!g) { setDetalleId(null); return null; }
    return (
      <div style={{ fontFamily: PP }}>
        <button onClick={() => setDetalleId(null)} style={{ background: colores.fondo, border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px 14px', fontSize: '13px', cursor: 'pointer', color: colores.gris, marginBottom: '16px' }}>{'←'} Volver</button>
        <div style={{ fontSize: '18px', fontWeight: '700', color: colores.gris, marginBottom: '4px' }}>{g.nombre}</div>
        <div style={{ fontSize: '13px', color: colores.grisClaro, marginBottom: '16px' }}>{g.cliente}</div>

        {/* KPIs */}
        <div style={{ display: 'grid', gridTemplateColumns: esCelular ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: '10px', marginBottom: '20px' }}>
          {[{ l: 'Invertido', v: '$' + g.totalInvertido.toLocaleString('es-MX', OPC_DINERO), c: colores.principal }, { l: 'Equipos', v: g.totalEquipos, c: '#1D9E75' }, { l: 'Técnicos', v: g.totalTecnicos, c: '#f4a261' }, { l: 'Tiempo', v: g.tiempoTotal, c: colores.oscuro }].map((k, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: '12px', padding: '14px', textAlign: 'center' }}>
              <div style={{ fontSize: '22px', fontWeight: '800', color: k.c }}>{k.v}</div>
              <div style={{ fontSize: '10px', color: colores.grisClaro, marginTop: '2px' }}>{k.l}</div>
            </div>
          ))}
        </div>

        {/* Timeline */}
        <div style={{ fontSize: '13px', fontWeight: '600', color: colores.grisClaro, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Timeline de proyectos</div>
        <div style={{ position: 'relative', paddingLeft: '24px' }}>
          <div style={{ position: 'absolute', left: '8px', top: 0, bottom: 0, width: '2px', background: '#e0e0e0' }} />
          {g.proyectos.map((p, i) => {
            const ec = estCfg[p.estatus] || estCfg.Programado;
            return (
              <div key={i} style={{ position: 'relative', marginBottom: '16px' }}>
                <div style={{ position: 'absolute', left: '-20px', top: '6px', width: '12px', height: '12px', borderRadius: '50%', background: ec.color, border: '2px solid #fff', zIndex: 1 }} />
                <div style={{ background: '#fff', borderRadius: '12px', padding: '14px', borderLeft: `3px solid ${ec.color}` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                    <BadgeFolio folio={p.folio} />
                    <span style={{ padding: '2px 8px', borderRadius: '6px', background: ec.bg, color: ec.color, fontSize: '10px', fontWeight: '600' }}>{p.estatus}</span>
                    <span style={{ fontSize: '11px', color: colores.grisClaro, marginLeft: 'auto' }}>{p.fecha}</span>
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris }}>{p.nombre}</div>
                  <div style={{ display: 'flex', gap: '12px', marginTop: '6px', fontSize: '12px', color: colores.grisClaro }}>
                    <span>${p.monto.toLocaleString('es-MX', OPC_DINERO)}</span>
                    {p.equipos > 0 && <span>{p.equipos} equipos</span>}
                    <span>{p.tecnico}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button style={{ width: '100%', padding: '12px', background: colores.oscuro, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: PP, marginTop: '10px' }}>Generar reporte ejecutivo</button>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: PP }}>
      <BarraBusqueda value={busqueda} onChange={setBusqueda} placeholder="Buscar por grupo o cliente..." />
      <ContadorResultados total={gruposData.length} filtrados={filtrados.length} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
        {filtrados.map(g => (
          <div key={g.id} onClick={() => setDetalleId(g.id)} style={{ background: '#fff', borderRadius: '14px', padding: '16px', cursor: 'pointer', borderLeft: `4px solid ${colores.principal}` }}>
            <div style={{ fontSize: '15px', fontWeight: '700', color: colores.gris, marginBottom: '4px' }}>{g.nombre}</div>
            <div style={{ fontSize: '12px', color: colores.grisClaro, marginBottom: '8px' }}>{g.cliente} · {g.proyectos.length} proyectos</div>
            <div style={{ display: 'flex', gap: '16px', fontSize: '12px' }}>
              <span style={{ color: colores.principal, fontWeight: '600' }}>${g.totalInvertido.toLocaleString('es-MX', OPC_DINERO)}</span>
              <span style={{ color: colores.grisClaro }}>{g.totalEquipos} equipos</span>
              <span style={{ color: colores.grisClaro }}>{g.tiempoTotal}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GruposProyectos;
